import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconWeightProps } from './IconWeight.types'
import * as Styled from './styles/IconWeight.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWeight: FC<IconWeightProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWeightProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconWeightProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.11 5.105c0 1.168-.95 2.122-2.122 2.122a2.126 2.126 0 0 1-2.12-2.122 2.12 2.12 0 0 1 4.242 0Zm6.347 13.809a1.59 1.59 0 0 1-.219 1.434 1.58 1.58 0 0 1-1.289.664c-2.367 0-6.52 0-9.797.004H5.047a1.589 1.589 0 0 1-1.5-2.102l3.441-9.86a1.6 1.6 0 0 1 1.5-1.074m0 0h8.192c.793 2.31 2.86 8.204 3.777 10.934'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconWeight
